<template lang="pug">
  Drawer( :title="title" ref="drawer" @hide="$emit('hide')" )
    add-grouped-to-list-drawer(v-if="state === 'product'" :buyRequest="registryBuyRequest" @done="setState('pick-list')" listType="Registry")
    pick-registry(v-else-if="state === 'pick-list'" :buyRequest="registryBuyRequest" @hide="$emit('hide')")
    create-registry(v-else-if="state === 'create'" @save="listSaved($event)" @delete="drawer?.hide()" :editListId="editListId")
</template>
<script setup lang="ts">
import { ref, computed } from 'vue'
import { useProductStore } from '@/js/stores/productStore'
import { createBuyRequest } from '@/js/helpers/buy-request'
import { useRogue } from '@/js/services/Rogue'
import PickRegistry from './pick-registry.vue'
import CreateRegistry from './create-registry.vue'
import AddGroupedToListDrawer from '../add-grouped-to-list-drawer.vue'
import type { BuyRequest } from '@/js/services/RogueTypes'
import Drawer from 'sisu/components/core/Drawer.vue'

const props = defineProps<{
  buyRequest?: BuyRequest
  editListId?: string | null
}>()

const emit = defineEmits(['hide'])

const productStore = useProductStore()
const rogue = useRogue()
const drawer = ref<typeof Drawer | null>(null)

const title = ref('')
const state = ref('')
const selectedList = ref<any>(null)
const registryBuyRequest = ref<any>(null)

const products = computed(() => productStore.products)

const product = computed(() => {
  if (Array.isArray(props.buyRequest) || !props.buyRequest?.productId) return null

  return products.value[props.buyRequest.productId]
})

const setState = (newState = 'create') => {
  state.value = newState
  title.value = rogue.__('Add to Gear Registry')

  if (newState === 'create') {
    title.value = props.editListId ? rogue.__('Edit Registry') : rogue.__('Create New Registry')
  } else if (newState === 'pick-list') {
    title.value = rogue.__('Add items to registry')
  }
}

const listSaved = (list: any) => {
  if (props.buyRequest) {
    selectedList.value = list
    setState('pick-list')
  } else {
    drawer.value?.hide()
  }
}

if (Array.isArray(props.buyRequest)) {
  registryBuyRequest.value = JSON.parse(JSON.stringify(props.buyRequest))
  setState('pick-list')
}

else if (product.value) {
  if (product.value.rhpaDisplayType === 'swatch') {
    registryBuyRequest.value = createBuyRequest({ ...product.value, rhpaDisplayType: undefined }, rogue)
  } else {
    registryBuyRequest.value = JSON.parse(JSON.stringify(props.buyRequest))
  }

  const hasRecipe = (props.buyRequest as any)?.metadata?.recipe
  const isStandardType = ['configurable', 'simple', 'bundle'].includes(product.value.type)

  if (isStandardType || hasRecipe) {
    setState('pick-list')
  } else {
    registryBuyRequest.value.children?.forEach((child: any) => (child.qty = 0))
    setState('product')
  }
} else {
  setState('create')
}

</script>
<style lang="scss" scoped>

</style>
